module.exports = __webpack_public_path__ + "static/media/heri_dating_content.3ec85b66.png";